
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText } from 'lucide-react';

const Documents = () => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Documents Hub</h1>
          <p className="text-muted-foreground">
            Central repository for all documents and files.
          </p>
        </div>
        <Button>
          <FileText className="mr-2 h-4 w-4" /> Upload Document
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Document Management</CardTitle>
          <CardDescription>Manage regulatory documents and internal files</CardDescription>
        </CardHeader>
        <CardContent className="flex items-center justify-center h-64">
          <p className="text-muted-foreground text-center">
            The Documents Hub module is under development.<br />
            Check back soon for complete access to document management tools.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Documents;
